import React from 'react'

const Welcome =() => {
    return (
        <div className='welcome'>
            <p>Thank you for checking out</p>
            <span className='welcome-a'><p> Mr Gadget</p></span>
            <p> created by <span className='welcome-b'>Burak Kocak</span></p>
            <p><a href="mailto:burakkocak884@gmail.com" target="_blank" rel="noopener noreferrer"><i class="envelope icon"></i></a></p>

        </div>
    )
}
export default Welcome